import { useGlobalState } from './';
import { Asset } from '../helpers';

export const useStatus = ({ setState, assetCategory }) => {
  const [settings] = useGlobalState('settings');
  const [statuses] = useGlobalState('statuses');

  const appendStatus = obj => {
    // Default is to provide setState and assetCategory on useStatus level,
    // but they can also be provided on each appendStatus call.
    // This is used in e.g. Attribute view which uses multiple appendStatus calls for different assets
    const _setState = obj?.setState || setState;
    const _assetCategory = obj?.assetCategory || assetCategory;

    const allowedAssetCategories = [Asset.Glossary, Asset.System];
    if (!allowedAssetCategories.includes(_assetCategory))
      throw `Invalid assetCategory, must be any of the following: ${allowedAssetCategories.join(', ')}`;

    if (settings[`SHOW_${_assetCategory.toUpperCase()}_STATUSES`]) {
      _setState(prev =>
        prev.map(x => ({
          ...x,
          status_name: statuses[x.status_id]?.label,
          status_description: statuses[x.status_id]?.tooltip,
        }))
      );
    }
  };

  return {
    appendStatus,
  };
};
